import { render, staticRenderFns } from "./MailHead.vue?vue&type=template&id=17f528c6&scoped=true&"
import script from "./MailHead.vue?vue&type=script&lang=js&"
export * from "./MailHead.vue?vue&type=script&lang=js&"
import style0 from "./MailHead.vue?vue&type=style&index=0&id=17f528c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17f528c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17f528c6')) {
      api.createRecord('17f528c6', component.options)
    } else {
      api.reload('17f528c6', component.options)
    }
    module.hot.accept("./MailHead.vue?vue&type=template&id=17f528c6&scoped=true&", function () {
      api.rerender('17f528c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/MailHead.vue"
export default component.exports